import { render, staticRenderFns } from "./ReportButton.vue?vue&type=template&id=2b19ae47&scoped=true&"
import script from "./ReportButton.vue?vue&type=script&lang=js&"
export * from "./ReportButton.vue?vue&type=script&lang=js&"
import style0 from "./ReportButton.vue?vue&type=style&index=0&id=2b19ae47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19ae47",
  null
  
)

export default component.exports